import script from "./BerechtigungView.vue?vue&type=script&setup=true&lang=js"
export * from "./BerechtigungView.vue?vue&type=script&setup=true&lang=js"

import "./BerechtigungView.vue?vue&type=style&index=0&id=2cbb70d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbb70d2"]])

export default __exports__